import React from 'react';
import Login from '../pages/login';
import ResetPassword from '../pages/reset-password';

export const publicRoutes = [
    { path: `${process.env.PUBLIC_URL}/login`, Component: <Login /> },
    { path: `${process.env.PUBLIC_URL}/reset`, Component: <ResetPassword /> },
  ];

export default publicRoutes;